import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import ProjectForm from "../../components/forms/ProjectForm";
import { FormMode } from "../../types/enums";

const UpdateProjectPage = (props) => (
  <Page enableGoBack title="Project wijzigen">
    <CenteredPageContentContainer>
      <PaperContainer title="Project wijzigen">
        <ProjectForm
          mode={FormMode.UPDATE}
          companyEmail={props.match.params.company_email}
          projectId={props.match.params.project_id}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

UpdateProjectPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      company_email: PropTypes.string.isRequired,
      project_id: PropTypes.string.isRequired,
    }),
  }),
};

export default UpdateProjectPage;



// WEBPACK FOOTER //
// ./src/pages/Project/UpdateProjectPage.js